import { Modal, Input, Select, Form, Button } from "antd";
import styled, { css } from "styled-components";

export const ModalForm = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    padding: 5px;
  }

  .ant-modal-header {
    border-radius: 10px 10px 0 0;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    border-top: none;
  }
`;

export const ModalRegisterSuccess = styled(Modal)`
  max-width: 425px;
  max-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  .ant-modal-content {
    border-radius: 10px;
    padding: 5px;
  }
  .ant-modal-header {
    border-bottom: none; /* Remove o divisor do rodapé */
  }

  .ant-modal-footer {
    border-top: none; /* Remove o divisor do rodapé */
  }
`;

export const ModalDelete = styled(Modal)`
  max-width: 444px;
  display: flex;
  justify-content: center;
  align-items: center;
  .ant-modal-content {
    border-radius: 10px;
    padding: 5px;
  }
  .ant-modal-header {
    border-bottom: none;
  }

  .ant-modal-footer {
    border-top: none;
  }
`;

export const ModalTitle = styled.div`
  max-width: 658px;
  font-family: "Inter";
  font-weight: 600;
  font-size: 20px;
  margin-left: 10px;
`;

export const StyledInput = styled(Input)`
  border-radius: 10px;
  width: 100%;
  height: 48px !important;
  padding-inline: 8px;
  border: 1px solid rgba(223, 223, 224, 1);
  &::placeholder {
    color: rgba(104, 104, 110, 1);
  }
`;

export const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 10px !important;
    height: 48px !important;
    display: flex;
    align-items: center;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    font-size: 14;
    line-height: 150%;
    letter-spacing: 0px;
  }

  .ant-select-dropdown {
    border-radius: 10px;
    width: auto !important;
  }

  .ant-select-item {
    width: auto !important;
  }

  .ant-select-selection-placeholder {
    color: rgba(104, 104, 110, 1) !important;
  }

  .ant-select-selection-search-input {
    height: 100% !important;
  }
`;

export const StyledDDISelect = styled(Select)`
  width: 101px !important;
  font-family: "Inter", sans-serif;

  .ant-select-dropdown {
    width: 340px !important;
  }
  .ant-select-item {
    width: 100% !important;
    box-sizing: border-box;
    font-family: "Inter", sans-serif;
    font-size: 14px;
  }
  .ant-select-item-option-content {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
  .ant-select-selector {
    width: 101px !important;
    height: 48px !important;
    border-radius: 10px !important;
    border: 1.5px solid var(--stroke-soft, rgba(223, 223, 224, 1));
    box-shadow: 0px 1px 2px rgba(25, 25, 28, 0.04);
    background-color: #ffffff !important;
    padding: 12px;
    display: flex;
    align-items: center;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 400;
  }
  .ant-select-selection-placeholder {
    color: #68686e !important;
    font-family: "Inter", sans-serif;
    font-size: 14px;
  }

  .ant-select-selection-item {
    display: flex !important;
    align-items: center;
    line-height: 24px;
    font-family: "Inter", sans-serif;
    font-size: 14px;
  }

  .ant-select-arrow {
    color: #000;
  }

  .ant-select-selection-search-input {
    height: 100% !important;
  }
`;

export const FlagOption = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  line-height: normal;

  svg {
    display: block;
    width: 18px;
    height: 13px;
    flex-shrink: 0;
    border-radius: 2px;
  }
`;

export const PhoneErrorText = styled.div`
  color: #ff4d4f;
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 24px;
`;

export const Flex = styled.div`
  display: flex;
  align-items: ${({ items }) => items ?? "center"};
  justify-content: ${({ justify }) => justify ?? "center"};
  flex-direction: ${({ direction }) => direction ?? "row"};
  flex-wrap: ${({ wrap }) => wrap ?? "nowrap"};
  gap: ${({ gap }) => gap ?? "0px"};

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `};

  ${({ flex }) =>
    flex &&
    css`
      flex: 1;
    `};

  ${({ full }) =>
    full &&
    css`
      width: 100%;
    `};

  ${({ mb }) =>
    mb &&
    css`
      margin-bottom: ${mb};
    `};
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
  .ant-form-item-label > label {
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0px;
    color: #314158;
  }

  .ant-form-item-label
    > label.ant-form-item-required:not(
      .ant-form-item-required-mark-optional
    )::before {
    content: "";
  }

  .ant-form-item-label
    > label.ant-form-item-required:not(
      .ant-form-item-required-mark-optional
    )::after {
    display: inline-block;
    margin-left: 0;
    color: #ff385c;
    font-size: 14px;
    line-height: 1;
    content: "*";
  }

  textarea {
    border-radius: 10px;
    width: 100%;
    padding-inline: 8px;
    border: 1px solid rgba(223, 223, 224, 1);
    box-shadow: 0px 1px 2px 0px rgba(25, 25, 28, 0.04);
  }
`;
export const StyledSpan = styled.span`
  margin-bottom: 8px;
  color: rgba(49, 65, 88, 1);
  font-weight: 400;
  font-size: 16px;
  font-family: "Inter";
`;

export const ButtonFormConfirm = styled(Button)`
  font-family: "Inter", sans-serif;
  border-radius: 10px;
  border: none;
  font-weight: 600;
  font-size: 14px;
  width: 108px;
  margin-top: 0px;
`;

export const CautionContainer = styled.div`
  margin-top: -15px;
  margin-bottom: 15px;
  font-size: 14px;
  color: rgba(98, 116, 142, 1);
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EventParticipationContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const TelephoneSpan = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;

  .required {
    color: #ff385c;
  }
`;
export const HeaderModal = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;
export const CollaboratorToDeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;
export const CollaboratorToDeleteLabel = styled.div`
  border-radius: 10px;
  border: 1px solid rgba(226, 232, 240, 1);
  font-weight: 400;
  font-size: 16px;
  font-family: "Inter";
  margin-top: 8px;
  padding: 5px;
  padding-left: 15px;
  color: rgba(98, 116, 142, 1);
`;

export const CustomExtraLabel = styled.span`
  margin: 0 4px;
  color: rgba(49, 65, 88, 0.5);
  font-size: 12px;
`;
